
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';

import metadata from './MLClaimDetailsProperty.metadata.json5';
import './MLClaimDetailsProperty.messages';

function MLClaimDetailsProperty(props) {
    const {
        lossLocation
    } = props;


    const getLossLocationAddress = () => {
        if (lossLocation) {
            return <>
                {lossLocation.addressLine1}
                <br />
                {`${lossLocation.city}, ${lossLocation.state} ${lossLocation.postalCode}`}
            </>
        }
    };

    const overrides = {
        locationAdress: {
            content: getLossLocationAddress()
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsProperty;
